import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { VideoOff, MicOff, ShieldAlert } from "lucide-react";

const COPY = {
  permissions: "Your browser blocked camera and microphone access for MoYo Stars Date.",
  "not-found": "We couldn't find a camera or microphone on this device.",
  "in-use": "Your camera or mic is being used by another app (Zoom, FaceTime, WhatsApp…).",
  unknown: "We couldn't start your camera or microphone.",
};

export function MediaPermissionDialog({ error, onRetry, onClose }) {
  return (
    <Dialog open={!!error} onOpenChange={(o) => !o && onClose()}>
      <DialogContent data-testid="media-permission-dialog" className="glass border-pink-500/30 max-w-sm">
        <DialogHeader>
          <div className="h-14 w-14 rounded-2xl bg-pink-500/15 flex items-center justify-center mx-auto mb-2"><ShieldAlert className="h-7 w-7 text-pink-300" /></div>
          <DialogTitle className="font-display text-xl text-center">Camera and Mic Permission Denied</DialogTitle>
          <DialogDescription className="text-center text-slate-300">{COPY[error] || COPY.unknown}</DialogDescription>
        </DialogHeader>
        <ol className="text-sm text-slate-300 space-y-1.5 list-decimal pl-5">
          <li>Tap the lock / camera icon in your browser's address bar.</li>
          <li>Set <b>Camera</b> and <b>Microphone</b> to <b>Allow</b>.</li>
          <li>On phones, also check Settings → your browser → Camera &amp; Microphone.</li>
          <li>Close other apps using the camera, then tap Try again.</li>
        </ol>
        <div className="flex gap-2 mt-2">
          <Button data-testid="media-permission-close" variant="outline" onClick={onClose} className="flex-1 rounded-full border-white/15"><VideoOff className="h-4 w-4 mr-1.5" /> Continue</Button>
          <Button data-testid="media-permission-retry" onClick={onRetry} className="flex-1 btn-gold rounded-full"><MicOff className="h-4 w-4 mr-1.5" /> Try again</Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}

export function PartnerMediaBanner({ name, video, audio }) {
  if (!video && !audio) return null;
  const what = video && audio ? "camera and mic are" : video ? "camera is" : "mic is";
  return (
    <div data-testid="partner-media-blocked" className="absolute bottom-24 inset-x-4 sm:inset-x-auto sm:left-1/2 sm:-translate-x-1/2 glass rounded-2xl px-4 py-3 border-pink-500/40 flex items-center gap-3 max-w-md">
      <ShieldAlert className="h-5 w-5 text-pink-300 shrink-0" />
      <p className="text-sm text-slate-200"><b>{name}</b>'s {what} blocked — their device denied media access. Ask them to allow camera &amp; mic in their browser and rejoin.</p>
    </div>
  );
}
